import { ADD_INGREDIENT, DELETE_INGREDIENT, SET_INGREDIENTS, INGREDIENTS_ERROR, ADD_FAMILY, GET_FAMILIES } from '../ActionTypes/IngredientVTypes';
import axios from 'axios';




// Action pour ajouter une famille
export const addFamily = (familyName) => async (dispatch) => {
  try {
    const response = await axios.post('/api/IngredientV/addfamilly', { name: familyName }); // Envoie à l'API pour ajouter la famille
    dispatch({
      type: ADD_FAMILY,
      payload: response.data.family, // Renvoie la famille ajoutée
    });
  } catch (error) {
    dispatch({
      type: INGREDIENTS_ERROR,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};

export const getFamily = () => async (dispatch) => {
  try {
    const response = await axios.get('/api/IngredientV/families'); // Appel à l'API
    console.log("Données reçues de l'API :", response.data); // Vérifiez les familles ici
    dispatch({
      type: GET_FAMILIES,
      payload: response.data, // Charge utile : les données des familles
    });
  } catch (error) {
    console.error("Erreur lors de la récupération des familles :", error);
    dispatch({
      type: INGREDIENTS_ERROR,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};


// Action pour ajouter un ingrédient
export const addIngredient = (familyName, ingredientName) => async (dispatch) => {
  try {
    const response = await fetch('/api/IngredientV/add-ingredient', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ familyName, ingredientName }),
    });

    const data = await response.json();

    if (response.ok) {
      dispatch(getFamily()); // Recharge les familles
    } else {
      console.error('Erreur lors de l\'ajout de l\'ingrédient:', data.message);
    }
  } catch (error) {
    console.error('Erreur serveur lors de l\'ajout de l\'ingrédient:', error);
  }
};

// Action pour supprimer une famille
export const deleteFamily = (familyName) => async (dispatch) => {
  try {
    // Effectuez une requête pour supprimer la famille de la base de données
    // Exemple : await axios.delete(`/api/families/${familyName}`);

    dispatch({
      type: DELETE_INGREDIENT,
      payload: familyName, // Supprime la famille du state global
    });
  } catch (error) {
    dispatch({
      type: INGREDIENTS_ERROR,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};

// Action pour ajouter un ingrédient à une famille


// Action pour supprimer un ingrédient d'une famille
export const deleteIngredient = (familyName, ingredientName) => async (dispatch) => {
  try {
    // Supprimez l'ingrédient de la famille dans la base de données
    // Exemple : await axios.delete(`/families/${familyName}/ingredients/${ingredientName}`);

    dispatch({
      type: DELETE_INGREDIENT,
      payload: { familyName, ingredientName },
    });
  } catch (error) {
    dispatch({
      type: INGREDIENTS_ERROR,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};


// Action pour récupérer les ingrédients d'une famille
export const setIngredients = (familyName) => async (dispatch) => {
  try {
    const response = await axios.get(`/families/${familyName}/ingredients`);
    dispatch({
      type: SET_INGREDIENTS,
      payload: response.data.ingredients,
    });
  } catch (error) {
    dispatch({
      type: INGREDIENTS_ERROR,
      payload: error.response.data.message || error.message,
    });
  }
};

export const updateFamily = (familyId, updatedData) => async (dispatch) => {
  try {
    const response = await axios.put(`/api/families/${familyId}`, updatedData);
    dispatch({ type: 'UPDATE_FAMILY_SUCCESS', payload: response.data });
  } catch (error) {
    console.error(error);
    dispatch({ type: 'UPDATE_FAMILY_FAILURE', payload: error });
  }
};


export const updateStockAlert = (id, stockAlert) => async (dispatch) => {
  try {
    const { data } = await axios.put(`/api/IngredientV/update-stock-alert/${id}`, { stockAlert });
    dispatch({ type: 'UPDATE_STOCK_ALERT', payload: data });
  } catch (error) {
    console.error('Erreur lors de la mise à jour du stock de sécurité', error);
  }
};

export const updateStock = (ingredientId, quantityUsed) => async (dispatch) => {
  try {
    const response = await axios.put(`/api/IngredientV/${ingredientId}/reduce`, { quantity: quantityUsed });
    dispatch({
      type: 'UPDATE_STOCK',
      payload: response.data,
    });
  } catch (error) {
    console.error('Erreur lors de la mise à jour du stock', error);
  }
};